import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addDesignation } from "../../redux/slices/registerSlice";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ067 } from "../../lib/google-analytics";
import { googleEvent_LOJ198 } from "../../lib/google-analytics-loan-journey-events";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Designation() {
  const [loading, setLoading] = useState(false);

  const { designation } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  const data = ["Associate", "Executive", "Manager", "Senior Manager", "CEO", "Other"];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);

    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res && res.statusCode === 200) {
      dispatch(addDesignation(data.value));
      if (repeatCustomer) {
        navigate("/confirm-details");
      } else {
        handleStep();
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ198();
  }, []);

  useEffect(() => {
    loading ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader();
  }, [loading]);

  return (
    <>
      <div className="wrapper">
        <MainHeader
          title="Employment Details"
          showProgress={true}
          percent={61.52}
          backPageName={repeatCustomer ? "/confirm-details" : ""}
        />
        <div className="mb-3">
          <p className="label">Your Designation</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "designation",
                value: item,
              });

              // Events
              googleEvent_LOJ067(item, item);
            }}
          >
            <SelectOption name={item} checked={designation} />
          </div>
        ))}
      </div>
    </>
  );
}
